import { createEvent, createStore } from 'effector';

export const setNotificationCount = createEvent<number>();
export const toggleNotificationDrawer = createEvent();

export type NotificationState = {
  drawer: boolean;
  newCount: number;
};

export const defaultNotificationState: NotificationState = {
  drawer: false,
  newCount: 0,
};
export const $notification = createStore<NotificationState>(
  defaultNotificationState,
);

$notification
  .on(setNotificationCount, (state, payload) => ({
    ...state,
    newCount: payload,
  }))
  .on(toggleNotificationDrawer, state => ({
    newCount: 0,
    drawer: !state.drawer,
  }));
